<template>
  <div class="cookPattenPage">
    <div>
      <el-tag class="tagDIV">{{ $t('Common.stage') }}{{ cookPhaseObj.index + 1 }}</el-tag>
      <span class="title">{{ $t('RecipeManage.listCookingPattern4') }}</span>
    </div>
    <div>
      <div class="formContent">
        <div class="spanTitle">{{ $t('RecipeManage.listPatten') }}:</div>
        <el-radio-group v-model="patten1.model" @change="PrePattenChange($event)">
          <el-radio :label="'THAW'" class="elRadioItem">
            {{ $t('RecipeManage.listThaw') }}
          </el-radio>
          <el-radio :label="'STEAM'" class="elRadioItem">{{
            $t('RecipeManage.listSteam')
          }}</el-radio>
          <el-radio :label="'ROAST'" class="elRadioItem">{{
            $t('RecipeManage.listBake')
          }}</el-radio>
          <el-radio :label="'BARBECUE'" class="elRadioItem">{{
            $t('RecipeManage.listBBC')
          }}</el-radio>
          <el-radio :label="'FRY'" class="elRadioItem"> {{ $t('RecipeManage.listFry') }}</el-radio>
          <el-radio :label="'GRILL'" class="elRadioItem">{{
            $t('RecipeManage.listGrill')
          }}</el-radio>
          <el-radio :label="'STEW'" class="elRadioItem">{{ $t('RecipeManage.listStew') }}</el-radio>
          <el-radio :label="'LOW_TEMPERATURE_COOKING'" class="elRadioItem">{{
            $t('RecipeManage.listLowTCook')
          }}</el-radio>
          <el-radio :label="'FERMENTATION'" class="elRadioItem">{{
            $t('RecipeManage.listFerment')
          }}</el-radio>
          <el-radio :label="'HEAT_PRESERVATION'" class="elRadioItem">{{
            $t('RecipeManage.listKeepT')
          }}</el-radio>
        </el-radio-group>
      </div>
      <div class="formContent">
        <div class="spanTitle">
          {{ $t('RecipeManage.listTips9')
          }}{{ `(${patten1.temperatureMin}~${patten1.temperatureMax}℃):` }}
        </div>
        <el-input-number
          style="margin: 24px 0"
          class="speInput"
          v-model="patten1.temperature"
          controls-position="right"
          :min="patten1.temperatureMin"
          :max="patten1.temperatureMax"
          @change="handleTemperature"
        ></el-input-number>
        <span class="solidUnit">℃</span>
        <span class="Funit"> ({{ CToF(patten1.temperature) }}℉)</span>
      </div>
      <div class="formContent">
        <div class="spanTitle">{{ $t('RecipeManage.listBakingTime') }}:</div>
        <div class="timeInputDiv">
          <el-input
            class="timeInput"
            v-model="patten1.time1"
            @blur="formatTime1"
            oninput="value=value.replace(/[^0-9.]/g,'')"
          >
          </el-input
          ><span class="iconSign">{{ $t('RecipeManage.hours') }}</span>
          <el-input
            class="timeInput"
            v-model="patten1.time2"
            @blur="formatTime2"
            oninput="value=value.replace(/[^0-9.]/g,'')"
          ></el-input
          ><span class="iconSign">{{ $t('RecipeManage.minutes') }}</span>
          <el-input
            class="timeInput"
            v-model="patten1.time3"
            @blur="formatTime3"
            oninput="value=value.replace(/[^0-9.]/g,'')"
          ></el-input>
          <span class="iconSign">{{ $t('RecipeManage.seconds') }}</span>
        </div>
        <span class="Funit"> {{ '(00:00:00~24:00:00)' }}</span>
      </div>
      <div class="formContent">
        <div class="spanTitle">
          {{ $t('RecipeManage.listTips5') }}{{ `(${humiSliderMin}~${humiSliderMax}%)` }}:
        </div>
        <el-slider
          class="sliderInput"
          :format-tooltip="formatSlider"
          :step="10"
          :min="humiSliderMin"
          :max="humiSliderMax"
          :marks="marksOfMoisture"
          show-stops
          v-model="patten1.humidity"
        >
        </el-slider>
        <el-input-number
          class="speInput"
          :min="humiSliderMin"
          :max="humiSliderMax"
          v-model="patten1.humidity"
          :step="10"
          size="small"
          step-strictly
        ></el-input-number>
        <span class="solidUnit">%</span>
      </div>
      <div class="formContent">
        <div class="spanTitle">{{ $t('RecipeManage.listTips6') }}:</div>
        <el-slider
          class="sliderInput"
          :step="10"
          :min="30"
          :max="100"
          show-stops
          v-model="patten1.fanRotateSpeed"
          :marks="marksOfDraughtFan"
        >
        </el-slider>
        <el-input-number
          class="speInput"
          :min="30"
          :max="100"
          v-model="patten1.fanRotateSpeed"
          :step="10"
          size="small"
          step-strictly
        ></el-input-number>
        <span class="solidUnit">{{ $t('RecipeManage.listRotateSpeed') }}</span>
      </div>

      <div class="formContent" style="margin-bottom: 0">
        <div class="spanTitle"></div>
        <el-radio-group v-model="patten1.fanDirection">
          <el-radio label="ProsAndCons">{{ $t('RecipeManage.listProsAndCons') }}</el-radio>
          <el-radio label="Pros">{{ $t('RecipeManage.listPros') }}</el-radio>
        </el-radio-group>
      </div>
      <div class="formContent" style="margin-bottom: 0;margin-top: 0">
        <div class="spanTitle"></div>
        <el-radio-group v-model="patten1.fanState">
          <el-radio label="OFF">{{ $t('RecipeManage.listOFF') }}</el-radio>
          <el-radio label="ON">{{ $t('RecipeManage.listON') }}</el-radio>
        </el-radio-group>
      </div>
      <div class="formContent" style="margin-top: 0">
        <div class="spanTitle">{{ $t('RecipeManage.listPause') }}:</div>
        <el-radio-group v-model="patten1.suspendState">
          <el-radio label="Unsuspended">{{ $t('RecipeManage.listUnsuspended') }}</el-radio>
          <el-radio label="Pause">{{ $t('RecipeManage.listPause') }}</el-radio>
        </el-radio-group>
      </div>
      <div class="formContent" style="height: 80px;align-items: baseline">
        <div class="spanTitle">
          {{ $t('RecipeManage.listStageDes') }}{{ `(${$t('Common.optional')})` }}:
        </div>
        <el-input
          type="textarea"
          :rows="4"
          v-model="patten1.remark"
          :placeholder="$t('RecipeManage.listStageDes')"
        ></el-input>
      </div>
    </div>
  </div>
</template>

<script>
import { CToF, formatNumber } from '@/utils/utils'
export default {
  name: 'cookPattenPre',
  props: {
    cookPhaseObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      // setDatePatten: {
      //   patten: 'THAW'
      // },
      patten1: {
        model: 'THAW',
        flowType: this.cookPhaseObj.flowType,
        stageName: this.cookPhaseObj.cookPhase
      },
      //解冻
      pattenOfThaw: {
        time1: '01',
        time2: '20',
        time3: '00',
        model: 'THAW',
        temperature: 40,
        temperatureMin: 30,
        temperatureMax: 40,
        time: '01:20:00',
        humidity: 100,
        fanRotateSpeed: 100,
        fanDirection: 'Pros',
        fanState: 'OFF',
        suspendState: 'Unsuspended',
        remark: '',
        flowType: this.cookPhaseObj.flowType,
        stageName: this.cookPhaseObj.stageName
      },
      //蒸
      pattenOfSteam: {
        time1: '00',
        time2: '50',
        time3: '00',
        model: 'STEAM',
        temperature: 100,
        temperatureMin: 30,
        temperatureMax: 140,
        time: '00:50:00',
        humidity: 100,
        fanRotateSpeed: 100,
        fanDirection: 'Pros',
        fanState: 'OFF',
        suspendState: 'Unsuspended',
        remark: '',
        flowType: this.cookPhaseObj.flowType,
        stageName: this.cookPhaseObj.stageName
      },
      //烘焙
      pattenOfBake: {
        time1: '00',
        time2: '20',
        time3: '00',
        model: 'ROAST',
        temperature: 170, //温度
        temperatureMin: 155,
        temperatureMax: 180,
        time: '00:20:00', //烤制时间
        humidity: 0, //湿度
        fanRotateSpeed: 100, //转速
        fanDirection: 'ProsAndCons', //正反转
        fanState: 'OFF', //半静态
        suspendState: 'Unsuspended', //加料状态
        remark: '',
        flowType: this.cookPhaseObj.flowType,
        stageName: this.cookPhaseObj.stageName
      },
      //烤肉
      pattenOfBBC: {
        time1: '00',
        time2: '20',
        time3: '00',
        model: 'BARBECUE',
        temperature: 180, //温度
        temperatureMin: 150,
        temperatureMax: 200,
        time: '00:20:00', //烤制时间
        humidity: 0, //湿度
        fanRotateSpeed: 100, //转速
        fanDirection: 'ProsAndCons', //正反转
        fanState: 'OFF', //半静态
        suspendState: 'Unsuspended', //加料状态
        remark: '',
        flowType: this.cookPhaseObj.flowType,
        stageName: this.cookPhaseObj.stageName
      },
      //炸
      pattenOfFry: {
        time1: '00',
        time2: '20',
        time3: '00',
        model: 'FRY',
        temperature: 220, //温度
        temperatureMin: 210,
        temperatureMax: 230,
        time: '00:20:00', //烤制时间
        humidity: 10, //湿度
        fanRotateSpeed: 100, //转速
        fanDirection: 'ProsAndCons', //正反转
        fanState: 'OFF', //半静态
        suspendState: 'Unsuspended', //加料状态
        remark: '',
        flowType: this.cookPhaseObj.flowType,
        stageName: this.cookPhaseObj.stageName
      },
      //烧烤
      pattenOfGrill: {
        time1: '00',
        time2: '20',
        time3: '00',
        model: 'GRILL',
        temperature: 230, //温度
        temperatureMin: 220,
        temperatureMax: 250,
        time: '00:20:00', //烤制时间
        humidity: 0, //湿度
        fanRotateSpeed: 100, //转速
        fanDirection: 'ProsAndCons', //正反转
        fanState: 'OFF', //半静态
        suspendState: 'Unsuspended', //加料状态
        remark: '',
        flowType: this.cookPhaseObj.flowType,
        stageName: this.cookPhaseObj.stageName
      },
      //炖
      pattenOfStew: {
        time1: '01',
        time2: '00',
        time3: '00',
        model: 'STEW',
        temperature: 130, //温度
        temperatureMin: 120,
        temperatureMax: 150,
        time: '01:00:00', //烤制时间
        humidity: 30, //湿度
        fanRotateSpeed: 80, //转速
        fanDirection: 'Pros', //正反转
        fanState: 'OFF', //半静态
        suspendState: 'Unsuspended', //加料状态
        remark: '',
        flowType: this.cookPhaseObj.flowType,
        stageName: this.cookPhaseObj.stageName
      },
      //低温烹饪
      pattenOfLowTCook: {
        time1: '02',
        time2: '00',
        time3: '00',
        model: 'LOW_TEMPERATURE_COOKING',
        temperature: 66, //温度
        temperatureMin: 50,
        temperatureMax: 80,
        time: '02:00:00', //烤制时间
        humidity: 100, //湿度
        fanRotateSpeed: 100, //转速
        fanDirection: 'Pros', //正反转
        fanState: 'OFF', //半静态
        suspendState: 'Unsuspended', //加料状态
        remark: '',
        flowType: this.cookPhaseObj.flowType,
        stageName: this.cookPhaseObj.stageName
      },
      //发酵
      pattenOfFerment: {
        time1: '02',
        time2: '30',
        time3: '00',
        model: 'FERMENTATION',
        temperature: 35, //温度
        temperatureMin: 30,
        temperatureMax: 40,
        time: '02:30:00', //烤制时间
        humidity: 30, //湿度
        fanRotateSpeed: 30, //转速
        fanDirection: 'Pros', //正反转
        fanState: 'OFF', //半静态
        suspendState: 'Unsuspended', //加料状态
        remark: '',
        flowType: this.cookPhaseObj.flowType,
        stageName: this.cookPhaseObj.stageName
      },
      //保持
      pattenOfKeepT: {
        time1: '01',
        time2: '00',
        time3: '00',
        model: 'HEAT_PRESERVATION',
        temperature: 70, //温度
        temperatureMin: 67,
        temperatureMax: 75,
        time: '01:00:00', //烤制时间
        humidity: 10, //湿度
        fanRotateSpeed: 30, //转速
        fanDirection: 'Pros', //正反转
        fanState: 'OFF', //半静态
        suspendState: 'Unsuspended', //加料状态
        remark: '',
        flowType: this.cookPhaseObj.flowType,
        stageName: this.cookPhaseObj.stageName
      },
      marksOfMoisture: {
        0: '0',
        10: '10',
        20: '20',
        30: '30',
        40: '40',
        50: '50',
        60: '60',
        70: '70',
        80: '80',
        90: '90',
        100: '100'
      },
      marksOfDraughtFan: {
        30: '30',
        40: '40',
        50: '50',
        60: '60',
        70: '70',
        80: '80',
        90: '90',
        100: '100'
      },
      humiSliderMin: 0,
      humiSliderMax: 100
    }
  },
  created() {
    if (this.cookPhaseObj.model) {
      this.patten1 = {
        ...this.initPrePatten(this.cookPhaseObj.model),
        ...this.cookPhaseObj,
        humidity: parseInt(this.cookPhaseObj.humidity),
        fanRotateSpeed: parseInt(this.cookPhaseObj.fanRotateSpeed)
      }
    } else {
      this.patten1 = {
        ...this.pattenOfThaw,
        ...this.cookPhaseObj,
        humidity: parseInt(this.cookPhaseObj.humidity),
        fanRotateSpeed: parseInt(this.cookPhaseObj.fanRotateSpeed)
      }
    }
    this.$nextTick(() => {
      this.handleTemperature(this.patten1.temperature)
    })
  },

  mounted() {
    if (this.cookPhaseObj.time.length > 0 && this.cookPhaseObj.time.split(':').length === 3) {
      console.log(this.cookPhaseObj.time.split(':'))
      this.patten1 = {
        ...this.patten1,
        ...this.cookPhaseObj,
        humidity: parseInt(this.cookPhaseObj.humidity),
        fanRotateSpeed: parseInt(this.cookPhaseObj.fanRotateSpeed),
        time1: this.cookPhaseObj.time.split(':')[0],
        time2: this.cookPhaseObj.time.split(':')[1],
        time3: this.cookPhaseObj.time.split(':')[2]
      }
    } else {
      this.patten1 = {
        ...this.patten1,
        ...this.cookPhaseObj,
        humidity: parseInt(this.cookPhaseObj.humidity),
        fanRotateSpeed: parseInt(this.cookPhaseObj.fanRotateSpeed),
        time: '00:00:00'
      }
    }
  },
  methods: {
    CToF,
    formatSlider(value) {
      return value + '%'
    },
    PrePattenChange(val) {
      console.log(val)
      switch (val) {
        case 'THAW':
          this.patten1 = {
            ...this.pattenOfThaw
          }
          this.$nextTick(() => {
            this.handleTemperature(this.pattenOfThaw.temperature)
          })
          // this.$set(this.patten1,this.pattenOfThaw)
          // this.patten1 = this.pattenOfThaw
          break
        case 'STEAM':
          this.patten1 = {
            ...this.pattenOfSteam
          }
          this.$nextTick(() => {
            this.handleTemperature(this.pattenOfSteam.temperature)
          })
          //this.$set(this.patten1,this.pattenOfSteam)
          //this.patten1 = this.pattenOfSteam
          break
        case 'ROAST':
          this.patten1 = {
            ...this.pattenOfBake
          }
          this.$nextTick(() => {
            this.handleTemperature(this.pattenOfBake.temperature)
          })
          //  this.patten1 = this.pattenOfBake
          break
        case 'BARBECUE':
          this.patten1 = {
            ...this.pattenOfBBC
          }
          this.$nextTick(() => {
            this.handleTemperature(this.pattenOfBBC.temperature)
          })
          // this.patten1 = this.pattenOfBBC
          break
        case 'FRY':
          this.patten1 = {
            ...this.pattenOfFry
          }
          this.$nextTick(() => {
            this.handleTemperature(this.pattenOfFry.temperature)
          })
          //this.patten1 = this.pattenOfFry
          break
        case 'GRILL':
          this.patten1 = {
            ...this.pattenOfGrill
          }
          this.$nextTick(() => {
            this.handleTemperature(this.pattenOfGrill.temperature)
          })
          // this.patten1 = this.pattenOfGrill
          break
        case 'STEW':
          this.patten1 = {
            ...this.pattenOfStew
          }
          this.$nextTick(() => {
            this.handleTemperature(this.pattenOfStew.temperature)
          })
          //this.patten1 = this.pattenOfStew
          break
        case 'LOW_TEMPERATURE_COOKING':
          this.patten1 = {
            ...this.pattenOfLowTCook
          }
          this.$nextTick(() => {
            this.handleTemperature(this.pattenOfLowTCook.temperature)
          })
          //this.patten1 = this.pattenOfLowTCook
          break
        case 'FERMENTATION':
          this.patten1 = {
            ...this.pattenOfFerment
          }
          this.$nextTick(() => {
            this.handleTemperature(this.pattenOfFerment.temperature)
          })
          // this.patten1 = this.pattenOfFerment
          break
        case 'HEAT_PRESERVATION':
          this.patten1 = {
            ...this.pattenOfKeepT
          }
          this.$nextTick(() => {
            this.handleTemperature(this.pattenOfKeepT.temperature)
          })
          // this.patten1 = this.pattenOfKeepT
          break
      }
    },
    initPrePatten(val) {
      switch (val) {
        case 'THAW':
          return this.pattenOfThaw
        case 'STEAM':
          return this.pattenOfSteam
        case 'ROAST':
          return this.pattenOfBake
        case 'BARBECUE':
          return this.pattenOfBBC
        case 'FRY':
          return this.pattenOfFry
        case 'GRILL':
          return this.pattenOfGrill
        case 'STEW':
          return this.pattenOfStew
        case 'LOW_TEMPERATURE_COOKING':
          return this.pattenOfLowTCook
        case 'FERMENTATION':
          return this.pattenOfFerment
        case 'HEAT_PRESERVATION':
          return this.pattenOfKeepT
      }
    },
    formatTime1(e) {
      if (e.target.value && parseInt(e.target.value) > 0 && parseInt(e.target.value) < 24) {
        this.patten1.time1 = formatNumber(e.target.value)
      } else if (e.target.value && parseInt(e.target.value) === 24) {
        this.patten1.time2 = '00'
        this.patten1.time3 = '00'
      } else if (e.target.value && parseInt(e.target.value) > 24) {
        this.patten1.time1 = '24'
        this.patten1.time2 = '00'
        this.patten1.time3 = '00'
      } else if (e.target.value && parseInt(e.target.value) < 1) {
        this.patten1.time1 = '00'
      } else if (e.target.value === '') {
        this.patten1.time1 = '00'
      }
      this.$nextTick(() => {
        this.patten1.time = this.patten1.time1 + ':' + this.patten1.time2 + ':' + this.patten1.time3
      })
    },
    formatTime2(e) {
      if (this.patten1.time1 === '24') {
        this.patten1.time2 = '00'
      } else if (e.target.value && parseInt(e.target.value) > 0 && parseInt(e.target.value) < 60) {
        this.patten1.time2 = formatNumber(e.target.value)
      } else if (e.target.value && parseInt(e.target.value) < 1) {
        this.patten1.time2 = '00'
      } else if (e.target.value && parseInt(e.target.value) > 59) {
        this.patten1.time2 = '59'
      } else if (e.target.value === '') {
        this.patten1.time2 = '00'
      }
      this.$nextTick(() => {
        this.patten1.time = this.patten1.time1 + ':' + this.patten1.time2 + ':' + this.patten1.time3
      })
    },
    formatTime3(e) {
      if (this.patten1.time1 === '24') {
        this.patten1.time3 = '00'
      } else if (e.target.value && parseInt(e.target.value) > 0 && parseInt(e.target.value) < 60) {
        console.log(parseInt(e.target.value))
        this.patten1.time3 = formatNumber(e.target.value)
      } else if (e.target.value && parseInt(e.target.value) < 1) {
        this.patten1.time3 = '00'
      } else if (e.target.value && parseInt(e.target.value) > 59) {
        this.patten1.time3 = '59'
      } else if (e.target.value === '') {
        this.patten1.time3 = '00'
      }
      this.$nextTick(() => {
        this.patten1.time = this.patten1.time1 + ':' + this.patten1.time2 + ':' + this.patten1.time3
      })
    },
    handleTemperature(val) {
      console.log('val', val)
      if (val > 229) {
        this.humiSliderMax = 10
        if (this.patten1.humidity > 10) {
          this.this.patten1.humidity = 10
        }
      } else if (val > 199 && val < 230) {
        this.humiSliderMax = 20
        if (this.patten1.humidity > 20) {
          this.this.patten1.humidity = 20
        }
      } else if (val > 129 && val < 200) {
        this.humiSliderMax = 30
        if (this.patten1.humidity > 30) {
          this.this.patten1.humidity = 30
        }
      } else if (val < 130) {
        this.humiSliderMax = 100
      }
      console.log(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.cookPattenPage {
  margin-top: 8px;
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  padding: 24px;
  .tagDIV {
    border: 0;
    font-size: 12px;
    line-height: 26px;
    height: 26px;
    border-radius: 13px;
    font-weight: 600;
  }
  .title {
    margin-left: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    line-height: 20px;
  }
  .formContent {
    margin: 24px 0;
    height: 40px;
    display: flex;
    align-items: center;
    .spanTitle {
      text-align: right;
      min-width: 165px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 32px;
      padding-right: 12px;
    }
    .timeInputDiv {
      display: flex;
      border: 1px solid #dcdfe6;
      border-radius: 6px;
      .iconSign {
        padding-right: 10px;
        line-height: 40px;
      }
    }
    /deep/ .timeInput {
      -webkit-appearance: none !important;
      width: 80px;
      .el-input__inner {
        border: 0;
      }
    }
    .Funit {
      font-size: 16px;
      margin-left: 8px;
      color: #999999;
    }
  }
  .speInput {
    width: 120px !important;
  }
  .sliderInput {
    width: 340px;
    margin-right: 24px;
  }
  .solidUnit {
    padding-left: 4px;
    color: #333333;
    line-height: 36px;
  }
  .elRadioItem {
    line-height: 32px;
    //margin: 12px;
  }
}
</style>
